import React, { forwardRef, MouseEvent, useCallback } from "react";

import cn from "classnames";

import ActivityType, {
  ActivityTypeRef,
} from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import ActivityTypeIcon from "@app/component/activity/ActivityTypeIcon";
import Chip, { ChipProps } from "@app/component/Chip";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./ActivityTypeChip.module.scss";

export interface ActivityTypeChipProps extends Omit<ChipProps, "icon" | "onClick"> {
  activityType: ActivityTypeRef;
  isAutoEmail?: boolean;
  onClick?: (
    activityType: Pick<ActivityType, "id" | "name">,
    event: MouseEvent<HTMLElement>
  ) => void;
  suppressTooltip?: boolean;
}

const ActivityTypeChip = forwardRef<HTMLDivElement, ActivityTypeChipProps>(
  ({ activityType, className, isAutoEmail, onClick, suppressTooltip, ...chipProps }, ref) => {
    const analytics = useAnalytics();
    const handleClick = useCallback(
      (event: MouseEvent<HTMLElement>) => {
        analytics.clicked(["Activity type"]);
        onClick?.(activityType, event);
      },
      [activityType, onClick, analytics]
    );
    return (
      <Chip
        className={cn(styles.chip, className)}
        icon={
          <ActivityTypeIcon
            activityType={activityType}
            isAutoEmail={isAutoEmail}
            size="sm"
            tooltipProps={suppressTooltip ? false : undefined}
          />
        }
        inline
        onClick={handleClick}
        ref={ref}
        {...chipProps}
      >
        {activityType.name}
      </Chip>
    );
  }
);

export default ActivityTypeChip;
